import { TeamOutlined } from '@ant-design/icons';
import Button from 'app/atoms/Button';

const EmptyState = ({ onInvite }: { onInvite: () => void }) => (
  <div className="flex flex-col items-center justify-center py-16 bg-white rounded-lg border">
    <TeamOutlined className="text-6xl text-[#D4380D] mb-4" />
    <h2 className="text-2xl font-semibold mb-2 font-figtree">No users yet</h2>
    <p className="text-gray-500 mb-4 font-figtree">Invite your first admin or content editor to get started.</p>
    <Button variant="primary" onClick={onInvite}>
      Invite user
    </Button>
  </div>
);

export default EmptyState;
